__turbopack_context__.v({
  "brandMark": "_8urLFq_brandMark",
  "combinationMark": "_8urLFq_combinationMark",
  "comment": "_8urLFq_comment",
  "content": "_8urLFq_content",
  "eTrustedRating": "_8urLFq_eTrustedRating",
  "eTrustedTeaser": "_8urLFq_eTrustedTeaser",
  "eTrustedWidget": "_8urLFq_eTrustedWidget",
  "fromDate": "_8urLFq_fromDate",
  "headline": "_8urLFq_headline",
  "quoteIcon": "_8urLFq_quoteIcon",
  "ratingContainer": "_8urLFq_ratingContainer",
  "ratingText": "_8urLFq_ratingText",
  "separator": "_8urLFq_separator",
  "star": "_8urLFq_star",
  "starOff": "_8urLFq_starOff",
  "starOn": "_8urLFq_starOn",
  "starRating": "_8urLFq_starRating",
  "verifiedRating": "_8urLFq_verifiedRating",
  "widgetFooter": "_8urLFq_widgetFooter",
  "wrapper": "_8urLFq_wrapper",
});
